import { render, staticRenderFns } from "./subTask.vue?vue&type=template&id=4f6d57fa&scoped=true&"
import script from "./subTask.vue?vue&type=script&lang=js&"
export * from "./subTask.vue?vue&type=script&lang=js&"
import style0 from "./subTask.vue?vue&type=style&index=0&id=4f6d57fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d57fa",
  null
  
)

export default component.exports